import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="text-center bold mb-3 mt-3">* * *</p>

    <p class="mb-3">
      La pleneco de materio inundis lin. 
      Jen densiĝis la juneco, tiom malproksima, jam travidebla, oscilanta, vakua. 
      Solidiĝis aĵoj en ilia firma tuŝebleco; ektintis, eksonoris, ekflamis sonoj; odoroj superŝutis lin kiel striktaj insuletoj; ĉio brilis en flavega varma suno.
    </p>

    <p class="mb-3">
      Vento de vivpleneco denove glitis sur liaj vangoj; maro…atendis lin…
    </p>
    
    <p class="mb-3">
      Laŭ kurbaj ŝtonaj stratetoj malsupreniris li al la maro. 
      Ŝtonaj koridoroj kondukis lin tien, kie, sub blua marĉielo, la rokoj montris sian grizan potencon. 
      La sama potenco tiris lin al kaskado de gutoj, grapoloj da akvo, kreskantaj sur blua ĉiela fono.
    </p>
    
    <p class="mb-3">
      «Fontanoj de kristal’», la vivifonto…
    </p>

    <p class="mb-3">
      Ankoraŭ unu paŝo – kaj per tuta sia pezo akvoarboj ruinfaligis lin, disbatante lin, dispecigante lin je la samaj gutoj, eroj, kiaj ili mem estis.
    </p>
    
    <p class="mb-3">
      Li kunsolviĝis kun la “primara potenco”.
    </p>
    `
  )
}

const itemName = {
  esp: 'Satori'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
    itemDate: 'La 17an de oktobro, 1989',
    itemPlace: 'Gurzuf',
  }
}

export default item;